<template>
  <div>

    <Spinner v-if="loading === true" />
    <div
        v-if="loading === false"
        class="row"
    >
      <div class="col-md-6" />
      <div class="col-md-6 create-button">
        <button
            type="button"
            class="btn btn-primary mb-2 ml-1"
            data-toggle="modal"
            data-target="#createModal"
        >
          Create
        </button>
        <create
            v-if="$router.currentRoute.name === 'notifications'"
            @refresh="getNotifications()"
        />
      </div>
    </div>
    <basic-table
        v-if="loading === false"
        :selectedPage = "'general_settings'"
        :actions-obj="actionsArray"
        ref="table"
        :columns="columns"
        :values="rows"
        @dynamicAction="handleActions($event)"
        @deleteItems="removeItems($event)"
        @choosenObject="catchMsg($event)"

    />
    <Content :text="content"/>
  </div>
</template>
<script>
import BasicTable from '../../../shared/tables/BasicTable.vue'
import notificationsService from '../../../services/notificationsService'
import Spinner from '@/shared/loader/Spinner'
import Content from './content'
import Create from './create'

export default {
  components: {
    Spinner,
    BasicTable,
    Content,
    Create
  },
  data() {
    return {
      loading: false,
      content: '',
      editedService: '',
      columns: [
        {
          label: 'Title',
          field: 'title',
        },
        {
          label: 'Message',
          field: 'body',
        },
        {
          label: 'Action',
          field: 'action',
        },
      ],
      rows: [],
      searchTerm: '',
    }
  },
  created() {
    this.getNotifications()
    this.actionsArray= [{ title: 'Send', icon: 'Edit3Icon' }, { title: 'Delete', icon: 'TrashIcon' }]
  },

  methods: {
    getNotifications(withLoading = true) {
      this.loading = true
      notificationsService.index().then(response => {
        this.rows =response.data.data
        this.loading = false
      })
    },
    catchMsg(obj){
      console.log(obj);
      this.content = obj.body
    },
    removeItems(arr) {
      this.loading = true
      this.confirmDeleteText(arr)
    },
    handleActions(itemObj) {
      switch (itemObj.key) {
        case 'Delete':
          this.confirmDeleteText([itemObj.id])
          break
        case 'Send':
          this.sendNotification([itemObj.id])
          break
        default:
          console.log('Action Object *******>', itemObj)
      }
      // this.$router.push({ name: 'representatives', params: { id: itemId } })
    },
    confirmDeleteText(arr) {
      if (arr.length > 0) {
        this.$swal({
          title: 'Are you sure?',
          text: "You won't be able to revert this!",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes, delete it!',
          customClass: {
            confirmButton: 'btn btn-primary',
            cancelButton: 'btn btn-outline-danger ml-1',
          },
          buttonsStyling: false,
        }).then(result => {
          if (result.value) {
            notificationsService.delete(arr.join()).then(response => {
              if (response && response.status === 200) {
                this.$swal({
                  icon: 'success',
                  title: 'Deleted!',
                  text: 'Your Items have been deleted.',
                  customClass: {
                    confirmButton: 'btn btn-success',
                  },
                }).then(() => {
                  this.getNotifications()
                })
              }
            }).catch(error => {
              this.loading = false
              return Promise.reject(error)
            })
          } else if (result.dismiss === 'cancel') {
            this.$swal({
              title: 'Cancelled',
              text: '',
              icon: 'error',
              customClass: {
                confirmButton: 'btn btn-success',
              },
            })
            this.loading = false
          } else {
            this.loading = false
          }
        })
      }
    },
    sendNotification(arr){
      if (arr.length > 0) {
        this.$swal({
          title: 'Are you sure Of Notify Process?',
          text: "You won't be able to revert this!",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes, Send it!',
          customClass: {
            confirmButton: 'btn btn-primary',
            cancelButton: 'btn btn-outline-danger ml-1',
          },
          buttonsStyling: false,
        }).then(result => {
          if (result.value) {
            notificationsService.send(arr.join()).then(response => {
              if (response && response.status === 200) {
                this.$swal({
                  icon: 'success',
                  title: 'Sent!',
                  text: 'YourNotification Has Sent Successfully.',
                  customClass: {
                    confirmButton: 'btn btn-success',
                  },
                }).then(() => {
                  this.getNotifications()
                })
              }
            }).catch(error => {
              this.loading = false
              return Promise.reject(error)
            })
          } else if (result.dismiss === 'cancel') {
            this.$swal({
              title: 'Cancelled',
              text: '',
              icon: 'error',
              customClass: {
                confirmButton: 'btn btn-success',
              },
            })
            this.loading = false
          } else {
            this.loading = false
          }
        })
      }
    }
  },

}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-good-table.scss';
</style>
